import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavedGroceryInput } from '@/models/grocery';

export const updateSavedGrocery = async (savedGrocery: SavedGroceryInput) => {
  const response = await mutationExecute({
    variables: {
      savedGrocery,
    },
    mutation: graphql(`
      mutation UpdateSavedGrocery($savedGrocery: SavedGroceryInputType!) {
        updateSavedGrocery(savedGrocery: $savedGrocery) {
          id
        }
      }
    `),
  });

  return !!response.data?.updateSavedGrocery;
};
